export const category = 'web_dialer'

export const RCON = 'rcon'
export const WEBAPP = 'webapp'
export const SPOG = 'spog'

export const ACTIONS = {
  OUTGOING: 'call_outgoing',
  INCOMING: 'call_incoming',
  BLOCKED: 'call_blocked',
  TRANSFER: 'call_transferred',
  TRANSFER_VOICEMAIL: 'call_transferred_voicemail',
  MERGED: 'calls_merged',
  PARK: 'call_parked',
  UNPARK: 'cal_unparked',
}

export const LABELS = {
  OUTGOING: {
    BACK: 'call_outgoing_call_back',
    CLICKED: 'call_outgoing_clicked',
    CONTACT: 'call_outgoing_contact',
    PASTED: 'call_outgoing_pasted',
    TYPED: 'call_outgoing_typed',
    UNKNOWN: 'unknown',
    ERROR: 'error',
  },
  INCOMING: 'call_incoming',
}

export const GA_TRACKING_ID = 'UA-161929910-1'
